import { gql, TypedDocumentNode } from "@apollo/client";

import { SEARCH_SUGGESTIONS_FRAGMENT } from "constants/suggestions";
import { SearchSuggestionsOutput, Stack } from "types/generated";

type SearchManagedEntitiesSuggestionsData = {
  searchManagedEntitiesSuggestions: SearchSuggestionsOutput;
};

export const SEARCH_MANAGED_ENTITIES_SUGGESTIONS: TypedDocumentNode<SearchManagedEntitiesSuggestionsData> = gql`
  query SearchManagedEntitiesSuggestions($input: SearchSuggestionsInput!) {
    searchManagedEntitiesSuggestions(input: $input) {
      ...SearchSuggestionsFragment
    }
  }
  ${SEARCH_SUGGESTIONS_FRAGMENT}
`;

type SearchStackManagedEntitiesSuggestionsData = {
  stack: Pick<Stack, "id" | "searchManagedEntitiesSuggestions">;
};

export const SEARCH_STACK_MANAGED_ENTITIES_SUGGESTIONS: TypedDocumentNode<SearchStackManagedEntitiesSuggestionsData> = gql`
  query SearchStackManagedEntitiesSuggestions($stackId: ID!, $input: SearchSuggestionsInput!) {
    stack(id: $stackId) {
      id
      searchManagedEntitiesSuggestions(input: $input) {
        ...SearchSuggestionsFragment
      }
    }
  }
  ${SEARCH_SUGGESTIONS_FRAGMENT}
`;
